import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IconPlusCircle',
  props: {
    color: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})